// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent {
  display: flex;
  direction: rtl;
}

mat-label {
  direction: rtl;
}

.title {
  position: relative;
  background-color: white;
  direction: rtl;
  margin-right: 10px;
}

.mat-grid-tile-content {
  margin-right: 12px !important;
}

.label {
  color: blue;
}

.field {
  margin-right: 2rem;
}

.app-port {
  margin-top: 10px;
  margin-bottom: 20px;
}

.label-all {
  direction: rtl;
  margin-bottom: 10px;
}

.box-transport-type {
  padding: 10px;
  background-color: #084e5f;
  color: white;
  border-radius: 10px;
  position: absolute;
  top: -62%;
  align-items: center;
  width: 50px;
  text-align: center;
  margin-top: 44px;
}

mat-card {
  margin-top: 20px !important;
  width: 100%;
  margin: auto;
  margin-bottom: 20px;
  padding: 10px;
}

mat-grid-list {
  margin-right: 20px;
}

.title {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/port-component/port-component.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/shared/components/port-component/port-component.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,cAAA;ACCJ;;ADEA;EACI,cAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,6BAAA;ACCJ;;ADIA;EACI,WAAA;ACDJ;;ADIA;EACI,kBAAA;ACDJ;;ADIA;EACI,gBAAA;EACA,mBAAA;ACDJ;;ADIA;EACI,cAAA;EACA,mBAAA;ACDJ;;ADIA;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;ACDJ;;ADIA;EACI,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;ACDJ;;ADIA;EACI,kBAAA;ACDJ;;ADIA;EACI,gBAAA;ACDJ","sourcesContent":[".parent {\r\n    display: flex;\r\n    direction: rtl;\r\n}\r\n\r\nmat-label {\r\n    direction: rtl;\r\n}\r\n\r\n.title {\r\n    position: relative;\r\n    background-color: white;\r\n    direction: rtl;\r\n    margin-right: 10px;\r\n}\r\n\r\n.mat-grid-tile-content {\r\n    margin-right: 12px !important;\r\n}\r\n\r\n\r\n\r\n.label {\r\n    color: blue;\r\n}\r\n\r\n.field {\r\n    margin-right: 2rem;\r\n}\r\n\r\n.app-port {\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.label-all {\r\n    direction: rtl;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.box-transport-type {\r\n    padding: 10px;\r\n    background-color: #084e5f;\r\n    color: white;\r\n    border-radius: 10px;\r\n    position: absolute;\r\n    top: -62%;\r\n    align-items: center;\r\n    width: 50px;\r\n    text-align: center;\r\n    margin-top: 44px;\r\n}\r\n\r\nmat-card {\r\n    margin-top: 20px !important;\r\n    width: 100%;\r\n    margin: auto;\r\n    margin-bottom: 20px;\r\n    padding: 10px;\r\n}\r\n\r\nmat-grid-list {\r\n    margin-right: 20px;\r\n}\r\n\r\n.title {\r\n    margin-top: 10px;\r\n}",".parent {\n  display: flex;\n  direction: rtl;\n}\n\nmat-label {\n  direction: rtl;\n}\n\n.title {\n  position: relative;\n  background-color: white;\n  direction: rtl;\n  margin-right: 10px;\n}\n\n.mat-grid-tile-content {\n  margin-right: 12px !important;\n}\n\n.label {\n  color: blue;\n}\n\n.field {\n  margin-right: 2rem;\n}\n\n.app-port {\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.label-all {\n  direction: rtl;\n  margin-bottom: 10px;\n}\n\n.box-transport-type {\n  padding: 10px;\n  background-color: #084e5f;\n  color: white;\n  border-radius: 10px;\n  position: absolute;\n  top: -62%;\n  align-items: center;\n  width: 50px;\n  text-align: center;\n  margin-top: 44px;\n}\n\nmat-card {\n  margin-top: 20px !important;\n  width: 100%;\n  margin: auto;\n  margin-bottom: 20px;\n  padding: 10px;\n}\n\nmat-grid-list {\n  margin-right: 20px;\n}\n\n.title {\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
